import { formatTime } from '../../../lib/base-i18n';
import { tCalendar } from '../../../lib/calendar-i18n';
import { inclusiveEndDayNumber, localDayNumber } from '../recurrence-dates';

/**
 * 우측 레일 카드의 시각 줄 (2026-10-20 사용자 지시 「연속 일정일 경우엔 날짜도 작성해줘. 월일 정도만」).
 *
 * 종전: 언제나 「오후 02:00–오후 04:00」(하루종일이면 「종일」) ⇒ 여러 날 일정이면 «어느 날» 시각인지 안 보였다.
 * 이제:
 * ```
 * 하루 안 · 시각      오후 02:00–오후 04:00                      (종전 그대로)
 * 하루 안 · 하루종일   종일                                       (종전 그대로)
 * 여러 날 · 시각      10월 20일 오후 02:00 – 10월 22일 오후 04:00
 * 여러 날 · 하루종일   10월 20일 – 10월 22일 · 종일
 * ```
 * ⚠ 날짜 셈은 월간 배치·상세 창·일간 표기와 같다 — 종료가 자정 정각이면 그 전날까지(inclusiveEndDayNumber).
 */
export function railTimeLabel(startAt: string, endAt: string, isAllDay: boolean): string {
  const start = new Date(startAt);
  const end = new Date(endAt);
  const startDay = localDayNumber(start);
  const endDay = inclusiveEndDayNumber(start, end);
  if (endDay <= startDay || Number.isNaN(startDay) || Number.isNaN(endDay)) {
    return isAllDay ? tCalendar('calendar.popover.allday') : `${formatTime(startAt)}–${formatTime(endAt)}`;
  }
  const md = (d: Date) => tCalendar('calendar.agenda.date_month_day', { m: d.getMonth() + 1, d: d.getDate() });
  if (isAllDay) {
    // 마지막 날 = 종료가 자정 정각이면 그 전날.
    const last = new Date(start.getFullYear(), start.getMonth(), start.getDate() + (endDay - startDay));
    return `${md(start)} – ${md(last)} · ${tCalendar('calendar.popover.allday')}`;
  }
  return `${md(start)} ${formatTime(startAt)} – ${md(end)} ${formatTime(endAt)}`;
}
